import React, { FC } from 'react';
import { TSocial } from './Contact';
import Numbers from './Numbers';

interface IInfo {
  social: TSocial;
  visible: boolean;
}

const Info: FC<IInfo> = ({ social, visible }): React.ReactElement => {
  const socialElements = Object.entries(social).map(([key, value], index) => {
    return (
      <li className="contact__social-item" key={`${value}_${index}`}>
        <a className="contact__social-link" href={value}>
          <img src={`/images/main/contact/images/icon/${key}.svg`} alt="Social icon" />
        </a>
      </li>
    );
  });

  return (
    <div className="contact__info">
      <h2 className="contact__info-title">We always answer!</h2>

      {visible ? (
        <ul className="contact__info-list">
          <li className="contact__info-item">
            <img src="/images/main/contact/images/icon/geolocation.svg" alt="Geolocation" />
            <span className="contact__info-text">
              <a
                className="contact__info-link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://goo.gl/maps/ofNXErEtcDZWH6xr9"
              >
                P.O.Box 17000 | 409 Jafza 17, Dubai, United Arab Emirates
              </a>
            </span>
          </li>

          <Numbers />
        </ul>
      ) : (
        <></>
      )}

      <ul className="contact__social">{socialElements}</ul>
    </div>
  );
};

export default Info;
